import { render, staticRenderFns } from "./Unconfirmed.vue?vue&type=template&id=238df1f4&"
import script from "./Unconfirmed.vue?vue&type=script&lang=js&"
export * from "./Unconfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Unconfirmed.vue"
export default component.exports